import { ARTICLE_LIST_FAIL, ARTICLE_LIST_REQUEST, ARTICLE_LIST_SUCCESS } from "../constats/article.constant";

export const articleListReducer = (state={}, action) => {
    switch (action.type) {
        case ARTICLE_LIST_REQUEST:
            return {
                loading: true
            };
        case ARTICLE_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        case ARTICLE_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            };
        default:
            return state;
    }
}